/*
* 教师评价页面
*/
<template>
    <div style="height: 100vh; background: #ffffff">
        <van-nav-bar placeholder title="教师评价" left-text="" left-arrow @click-left="onClickLeft()">
            <template #right>
            </template>
        </van-nav-bar>
      <div class="top-img">
        <img class="ok" src="@/assets/ok.png">
        <img class="ok-yy" src="@/assets/ok-yy.png">
      </div>
        <van-form @submit="onSubmit" v-show="record.teacherCode">
            <van-cell-group>
                <van-field label="教师编号" :value="record.teacherCode" readonly />
                <van-field label="教师名称" :value="record.name" readonly />
                <van-field label="院系" :value="facultyTypeOptions.some(i => i.value === record.faculty) ? facultyTypeOptions.filter(i => i.value === record.faculty)[0].label : '' " readonly />
                <van-field name="rate" label="评价得分">
                    <template #input>
                        <van-rate v-model="params.starNum" allow-half void-icon="star"  />
                    </template>
                </van-field>
                <van-field
                        v-model="params.commentContent"
                        label="评价内容"
                        type="textarea"
                        :maxlength="1000"
                        :rows="4"
                        placeholder="请输入评价内容"
                />
            </van-cell-group>

            <div class="b-but">
                <van-button block :loading="loading" type="info" native-type="submit">提交</van-button>
            </div>
        </van-form>
    </div>

</template>

<script>
    import {getBaseDetail, addComment} from '@/api/teacher/teacherInfo'
    import {FILE_DISPLAY_PREFIX} from '@/api/upload'
    import {getDictByType} from '@/api/common'
    import {getDictName} from '@/utils/common'

    export default {
        name: 'venueDetail',
        components: {},
        data() {
            return {
                fileDisplayPrefix: FILE_DISPLAY_PREFIX,
                teacherId: '',
                facultyTypeOptions: [],
                record: {},
                params: {
                    starNum: 5
                },
                getDictName,
                loading: false
            }
        },
        computed: {},
        created() {
            this.teacherId = this.$route.query.id;
            this.getTeacherDetail();
            // 查询字典，院系类型
            getDictByType('faculty_type').then(res => {
                if (res.code === 10000) {
                    this.facultyTypeOptions = res.result.map(item => {
                        return {label: item.dictKey, value: item.dictValue}
                    })
                }
            });
        },
        mounted() {
        },
        methods: {
            onSubmit(){
                this.loading = true;
                if(!this.record.id) {
                    this.loading = false;
                    return;
                }
                const data = {
                    teacherId: this.record.id,
                    content: this.params.commentContent.replaceAll('\n', "<br/>"),
                    starNum: this.params.starNum
                };
                addComment(data).then(res => {
                    if (res.code === 10000) {
                        this.$toast("评价成功!");
                        setTimeout(() => {
                            this.$router.go(-1)
                        }, 200)
                    }
                }).finally(() => {
                    setTimeout(() => {
                        this.loading = false
                    }, 200)
                });
            },
            onClickLeft(){
                this.$router.go(-1)
            },
            getTeacherDetail(){
                // 教师详情
                getBaseDetail(this.teacherId).then(res => {
                    if (res.code === 10000) {
                        this.record = res.result
                    }
                }).finally(() => {
                    setTimeout(() => {
                        this.loading = false
                    }, 100)
                });
            }
        }
    }
</script>

<style  scoped>
/deep/ .van-cell-group{
    height:284px;
    background: #EEF3F8;
    border-radius:6px;
  margin: 20px 10px;
  padding: 0 10px;
  }
/deep/.van-cell{
  background: none;
  border-bottom: 1px dashed #DEDEDE;
  padding:10px 0;
}
/deep/.van-rate__icon{
  font-size:14px;
}
/deep/.van-rate__icon--full{
  color: #6988FF;
}
/deep/.van-field__label{
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #777777;
  width:70px;
}
/deep/.van-cell__value{
  font-size:14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
/deep/.van-field--min-height .van-field__control{
  height:75px;
  background: #FFFFFF;
  border: 1px solid #DEDEDE;
  border-radius: 3px;
  padding:5px;
}
.top-img{
  display: flex;
  align-items:center;
  justify-content: center;
  position: relative;
  flex-direction: column;
  height:120px;
}
.top-img .ok{
  width:144px;
  height:94px;
  position: relative;
  z-index: 666;
}
.top-img .ok-yy{
  width:305px;
  height:90px;
  position: absolute;
  bottom:-30px;
  z-index: 1;
}
</style>
